import React, { PropsWithChildren } from 'react';
import cn from 'classnames';
import styles from './Alert.module.scss';
import { LoaderIcon, XIcon } from '@repo/icons';
import success from '/img/notifications/success.svg?url';
import error from '/img/notifications/error.svg?url';
import { AlertType } from '@repo/utils/types';
import SystemAlert, { alertColorMap } from '@repo/utils/models/SystemAlert';
import alertIconMap from '@repo/icons/AlertIcons';
import { useDispatch } from 'react-redux';
import { dismissSystemAlert } from '@repo/redux/actions/alerts';

const iconsByAlertType: { [key in AlertType]?: JSX.Element } = {
  loading: <LoaderIcon />,
  success: <img src={success} />,
  error: <img src={error} />,
};

export function SystemAlertDisplay({ alert }: { alert: SystemAlert }) {
  const dispatch = useDispatch();
  const AlertIcon = alertIconMap[alert.severity];
  const color = alertColorMap[alert.severity];

  return (
    <div className={styles.systemAlert} style={{ '--alertColor': color } as React.CSSProperties}>
      <AlertIcon />
      <h4 style={{ color }}>{alert.label}</h4>
      <button className={styles.dismissBtn} onClick={() => dispatch(dismissSystemAlert())}>
        <XIcon width="8" height="8" />
      </button>
      <p>
        {alert.message}{' '}
        <a href={alert.url} target="_blank">
          Learn More →
        </a>
      </p>
    </div>
  );
}

export function Alert({
  type,
  className,
  children,
}: PropsWithChildren<{ className?: string; type?: AlertType }>) {
  return (
    <span className={cn(styles.alert, 'text-small', className, type && styles[`alert-${type}`])}>
      {iconsByAlertType[type]}
      {children}
    </span>
  );
}
